<template>
  <div style="width: 100%">
    <div class="md-toolbar-section-start">
      <div class="md-layout md-gutter md-alignment-center-space-between" style="width: 100%">

        <div class="md-layout-item md-size-100">
          <div class="md-layout md-gutter md-alignment-center-space-between">
            <div class="md-layout-item md-size-25">
              <div class="md-layout md-gutter md-alignment-top-left">
 
                            <md-button style="margin-left:60px;" class="md-raised md-primary" @click="openPreviewDialog()">

                <span>Create User</span>
            </md-button>
              </div>
            </div>
            <div class="md-layout-item md-size-40">
              <div class="md-layout md-gutter md-alignment-top-right">
                <md-chip :class="roleSelect.includes(roles[0]) ? 'md-primary' : ''" @click="changeRole(roles[0])"
                  md-clickable>{{ labelsRoles[0] }}</md-chip>
                <md-chip :class="roleSelect.includes(roles[1]) ? 'md-primary' : ''" @click="changeRole(roles[1])"
                  md-clickable>{{ labelsRoles[1] }}</md-chip>
                <md-chip :class="roleSelect.includes(roles[2]) ? 'md-primary' : ''" @click="changeRole(roles[2])"
                  md-clickable>{{ labelsRoles[2] }}</md-chip>
                <md-chip :class="roleSelect.includes(roles[3]) ? 'md-primary' : ''" @click="changeRole(roles[3])"
                  md-clickable>{{ labelsRoles[3] }}</md-chip>
                <md-chip :class="roleSelect.includes(roles[4]) ? 'md-primary' : ''" @click="changeRole(roles[4])"
                  md-clickable>{{ labelsRoles[4] }}</md-chip>
              </div>
            </div>
            <md-field class="md-layout-item  md-size-30" style="margin-left: 20px">
              <label>Search</label>
              <md-input v-model="searchText" @change="findMatches()" />
            </md-field>
          </div>
        </div>
      </div>
    </div>
    <md-table v-model="paginatedtableData" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder"
      :md-sort-fn="customSort">
      <md-table-row style="max-height: 400px" slot="md-table-row" slot-scope="{ item, index }" md-selectable="single">
        <md-table-cell md-label="#" md-numeric>{{ index + 1 }}</md-table-cell>

        <md-table-cell md-label="Name" md-sort-by="firstName">{{
          item.firstName
        }}</md-table-cell>
        <md-table-cell md-label="Lastname" md-sort-by="lastName">{{
          item.lastName
        }}</md-table-cell>
        <md-table-cell md-label="Email" md-sort-by="email">{{
          item.email
        }}</md-table-cell>
        <md-table-cell md-label="Telephone">{{ item.phone }}</md-table-cell>
        <md-table-cell md-label="Roles" md-sort-by="role">
          <md-chip v-for="role in item.role" v-bind:key="role" style="background-color: #e74d1b2b;">{{
            labelsRoles[roles.indexOf(role)]
          }}</md-chip>
        </md-table-cell>
        <md-table-cell md-label="Birthday" md-sort-by="dateOfBirth">{{
          item.dateOfBirthFormat
        }}</md-table-cell>

        <md-table-cell md-label="Settings" style="min-width: 240px;">
          <md-button class="md-icon-button" @click="openPreviewDialog(item)" title="Edit user info">
            <md-icon>manage_accounts</md-icon>
          </md-button>
          <md-button class="md-icon-button" @click="openPassDialog(item)" title="Change user pass"
            v-if="isAdmin">
            <md-icon>vpn_key</md-icon>
          </md-button>
          <md-button class="md-icon-button" :style="isAdmin?'':'opacity:0.5;'"  @click="openDeleteDialog(item, index)" title="Enable/disable"
            :disabled="!isAdmin">
            <md-icon v-if="!item.disabled" style="color: green">check_circle</md-icon>
            <md-icon v-if="item.disabled" style="color: red">cancel</md-icon>
          </md-button>
          <md-button class="md-icon-button" @click="openDeleteDialog(item, index)" title="Delete"
            :disabled="!item.disabled">
            <md-icon >delete</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <div class="md-layout md-gutter md-alignment-center-right"
      style="margin-top: 15px; max-height: 400px; padding-right: 25px">
      <span class="md-layout-item md-size-15">Rows per page:</span>
      <div class="md-layout-item md-size-10">
        <md-field>
          <md-select v-model="rowsPerPage" @md-selected="
            currentPage = 1;
          updatePagination();
          ">
            <md-option value="5">5</md-option>
            <md-option value="10">10</md-option>
            <md-option value="15">15</md-option>
            <md-option value="20">20</md-option>
          </md-select>
        </md-field>
      </div>

      <span class="md-layout-item md-size-10">
        {{ initialRow + 1 + "-" + finalRow + " of " + totalRows }}</span>
      <div class="md-layout-item md-size-5">
        <md-button class="md-icon-button" @click="
          currentPage -= 1;
        updatePagination();
        " :disabled="currentPage == 1">
          <md-icon>chevron_left</md-icon>
        </md-button>
      </div>
      <div class="md-layout-item md-size-5">
        <md-button class="md-icon-button" @click="
          currentPage += 1;
        updatePagination();
        " :disabled="currentPage == totalPages">
          <md-icon>chevron_right</md-icon>
        </md-button>
      </div>
    </div>
    <md-dialog :md-active.sync="showPassDialog">
      <md-dialog-title>Change Password</md-dialog-title>
      <md-dialog-content style="padding: 30px">
        <md-field>
          <label>Change option</label>
          <md-select v-model="resetOption">
            <md-option value="sendEmail">Send an email to the user</md-option>
            <md-option value="changePass">Set a new password</md-option>
          </md-select>
        </md-field>
        <form action="" v-if="resetOption == 'sendEmail'">
          <h3>
            An email will be send to '{{
              selectedUserPass ? selectedUserPass.email : ""
            }}'
          </h3>
        </form>

        <form action="" v-if="resetOption == 'changePass'">
          <h4>The password must contain:</h4>
          <ul style="padding: 5px 30px">
            <li>Minimum eight characters</li>
            <li>At least one uppercase letter</li>
            <li>One lowercase letter</li>
            <li>One number</li>
            <li>
              One special character ({{
                "@, $, !, %, *, ?, " + "&, " + "#, " + "_"
              }})
            </li>
          </ul>

          <md-field :class="!validPass1 ? 'md-invalid' : ''">
            <label>Type Password</label>
            <md-input v-model="userPassData" type="password" required></md-input>
            <span class="md-error">Invalid password</span>
          </md-field>
          <md-field :class="!validPass2 ? 'md-invalid' : ''">
            <label>Re-Type Password</label>
            <md-input v-model="userRePassData" type="password" required></md-input>
            <span class="md-error">Invalid password</span>
          </md-field>
          <p style="color: #ff1744; padding: 10px 30px" v-if="userPassData !== userRePassData">
            <b>Error:</b> Password Fields does not match
          </p>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showPassDialog = false">Close</md-button>
        <md-button v-if="resetOption == 'sendEmail'" class="md-primary" @click="sendNewPass()">
          <span>Send Email</span>
        </md-button>
        <md-button v-if="resetOption == 'changePass'" class="md-primary" @click="saveUserPass()" :disabled="!validPass1 || !validPass2 || userPassData !== userRePassData
          ">
          <span>Save</span>
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showPreviewDialog">
      <md-dialog-title>User information</md-dialog-title>
      <md-dialog-content style="min-width: 600px; padding: 20px">
        <form action="">
          <md-field>
            <label>First name</label>
            <md-input autocomplete="nope" v-model="userDialogData.firstName" type="text" required></md-input>
          </md-field>

          <md-field>
            <label>Last name</label>
            <md-input autocomplete="nope" v-model="userDialogData.lastName" type="text" required></md-input>
          </md-field>

          <md-field>
            <label>Phone</label>
            <md-input autocomplete="nope" v-model="userDialogData.phone" type="text"></md-input>
          </md-field>

          <md-field>
            <label>Email</label>
            <md-input autocomplete="nope" v-model="userDialogData.email" type="text" required></md-input>
          </md-field>


          <CustomDateField label="Date of birth" v-model="userDialogData.dateOfBirth"/>
          <md-field>

            <label>Role</label>
            <md-select v-model="userDialogData.role" multiple required>
              <md-option v-for="(role, index) in roles" v-bind:key="role" :value="role">
                {{ labelsRoles[index] }}
              </md-option>
            </md-select>
          </md-field>
          <md-field v-if="newUserFlag" :class="!validPassNew ? 'md-invalid' : ''">
            <label>Password</label>
            <md-input autocomplete="new-password" type="password" v-model="userDialogData.password" required></md-input>
            <span class="md-error">Password must be at least 8 characters with 1 uppercase letter, 1
              lowercase letter, 1 number and 1 special character
            </span>
          </md-field>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showPreviewDialog = false">Close</md-button>
        <md-button class="md-primary" :disabled="!validUserEdit" @click="saveUserData()">Save
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showDeleteDialog">
      <md-dialog-title>Disable User</md-dialog-title>
      <md-dialog-content style="padding: 20px">
        <form action="">
          <h2>Do you want to disable the following user?</h2>
          <br />
          <div>
            <b>First name: </b>
            <label>{{ userDialogData.firstName }}</label>
          </div>

          <div>
            <b>Last name: </b>
            <label>{{ userDialogData.lastName }}</label>
          </div>

          <div>
            <b>Phone: </b>
            <label>{{ userDialogData.phone }}</label>
          </div>

          <div>
            <b>Email: </b>
            <label>{{ userDialogData.email }}</label>
          </div>
          <br />

          <md-field v-if="usersAssignListInitial.length > 0">
            <label>Assign this initial approver user's tasks to: </label>
            <md-select v-model="selectedAsigneeInitial">
              <md-option v-for="user in usersAssignListInitial" v-bind:key="user.id" :value="user.id">
                {{ user.firstName }} {{ user.lastName }}
              </md-option>
            </md-select>
          </md-field>
          <md-field v-if="usersAssignListFinal.length > 0">
            <label>Assign this final approver user's tasks to: </label>
            <md-select v-model="selectedAsigneeFinal">
              <md-option v-for="user in usersAssignListFinal" v-bind:key="user.id" :value="user.id">
                {{ user.firstName }} {{ user.lastName }}
              </md-option>
            </md-select>
          </md-field>
          <md-checkbox v-model="disableCancelSigns" class="md-primary">Cancel the transactions where the user has to sign</md-checkbox>
          <md-field v-if="!disableCancelSigns">
            <label>Assign task that need to be signed by this user to:</label>
            <md-input autocomplete="nope" v-model="selectedSigneeEmail" type="text" :required="!disableCancelSigns" :disabled="disableCancelSigns"></md-input>
          </md-field>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showDeleteDialog = false">Close</md-button>
        <md-button class="md-primary" :disabled="!validateDeletion" @click="deleteUser()">Disable
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showEnableDialog">
      <md-dialog-title>Enable User</md-dialog-title>
      <md-dialog-content style="padding: 20px">
        <form action="">
          <h2>Do you want to enable the following user?</h2>
          <br />
          <div>
            <b>First name: </b>
            <label>{{ userDialogData.firstName }}</label>
          </div>

          <div>
            <b>Last name: </b>
            <label>{{ userDialogData.lastName }}</label>
          </div>

          <div>
            <b>Phone: </b>
            <label>{{ userDialogData.phone }}</label>
          </div>

          <div>
            <b>Email: </b>
            <label>{{ userDialogData.email }}</label>
          </div>
          <br />
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showEnableDialog = false">Close</md-button>
        <md-button class="md-primary" @click="enableUser()">Enable </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-alert :md-active.sync="showError" :md-content="errorMsg" md-confirm-text="OK" />
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Vue from "vue";
import CustomDateField from "@/components/CustomDateField.vue";
export default {
  components: {
            CustomDateField,
        },
  computed: {
    validPass1() {
      return (
        this.userPassData &&
        this.userPassData.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_])[A-Za-z\d@$!%*?&#_]{8,}$/
        )
      );
    },
    validPass2() {
      return (
        this.userRePassData &&
        this.userRePassData.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_])[A-Za-z\d@$!%*?&#_]{8,}$/
        )
      );
    },
    validSend() {
      return this.sendEmail && this.sendEmail.length > 0;
    },
    validPassNew() {
      return (
        this.userDialogData.password &&
        this.userDialogData.password.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_])[A-Za-z\d@$!%*?&#_]{8,}$/
        )
      );
    },
    validUserEdit() {
      if (
        !this.userDialogData.firstName ||
        this.userDialogData.firstName === ""
      ) {
        return false;
      } else if (
        !this.userDialogData.lastName ||
        this.userDialogData.lastName === ""
      ) {
        return false;
      } else if (
        !this.userDialogData.email ||
        this.userDialogData.email === ""
      ) {
        return false;
      } else if (
        !this.userDialogData.dateOfBirth ||
        this.userDialogData.dateOfBirth === ""
      ) {
        return false;
      } else if (
        !this.userDialogData.role ||
        this.userDialogData.role.length === 0
      ) {
        return false;
      } else if (
        this.newUserFlag &&
        (!this.userDialogData.password ||
          !this.userDialogData.password.match(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_])[A-Za-z\d@$!%*?&#_]{8,}$/
          ))
      ) {
        return false;
      }
      return true;
    },
    validateDeletion() {
      if (
        this.usersAssignListInitial &&
        this.usersAssignListInitial.length > 0 &&
        !this.selectedAsigneeInitial
      ) {
        return false;
      } else if (
        this.selectedAsigneeFinal &&
        this.selectedAsigneeFinal.length > 0 &&
        !this.usersAssignListFinal
      ) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      dateTimeFormat: Vue.prototype.$generalConfiguration["dateTimeFormat"],
      dateFormat: localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateFormat"] : "yyyy.MM-dd",
      userDialogData: {},
      disableCancelSigns:true,
      labelsRoles: [
        "Admin",
        "Manager",
        "Signee",
        "Initial Approver",
        "Final Approver",
      ],
      roles: ["admin", "manager", "signee", "initial", "final"],
      rowsPerPage: 10,
      currentPage: 1,
      totalPages: 1,
      initialRow: 1,
      finalRow: 1,
      totalRows: 1,
      selected: {},
      tableData: [],
      searchText: "",
      paginatedtableData: [],
      newUserFlag: false,
      roleSelect: ["admin", "manager", "signee", "initial", "final"],
      showPreviewDialog: false,
      isAdmin: false,
      
      role: Vue.prototype.$userData.user.role[0],
      currentSortOrder: "asc",
      currentSort: "firstName",

      showPassDialog: false,
      resetOption: "sendEmail",
      userPassData: null,
      userRePassData: null,
      selectedUserPass: {},
      sendEmail: null,
      showEnableDialog: false,
      showDeleteDialog: false,
      selectedAsigneeInitial: null,
      selectedAsigneeFinal: null,
      selectedSigneeEmail: '',
      usersAssignListInitial: [],
      usersAssignListFinal: [],
      allUsers: [],
      showError: false,
      errorMsg: "Error",
    };
  },
  methods: {
    customSort() {
      return this.tableData
        .sort((a, b) => {
          const sortBy = this.currentSort;
          var valA = JSON.stringify(a[sortBy]);
          var valB = JSON.stringify(b[sortBy]);
          if (this.currentSortOrder !== "desc") {
            return valA.localeCompare(valB);
          }
          return valB.localeCompare(valA);
        })
        .filter((element, index) => {
          return index >= this.initialRow && index < this.finalRow;
        });
    },

    usersList() {
      axios({
        method: "get",
        url: "/users/getAllUsersWithDisabled",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
      })
        .then((response) => {
          this.allUsers = response.data.map((el) => {
            el.text = el.firstName + " " + el.lastName + " (" + el.email + ")";
            return el;
          });
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    findMatches() {
      if(!this.roleSelect || !this.roleSelect.length){
        this.tableData=[];
        this.currentPage = 1;
          this.updatePagination();
        return;
      }
      axios({
        method: "post",
        url: "/users/filterUsers",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          roles: this.roleSelect,
          searchText: this.searchText,
        },
      })
        .then((response) => {
          this.tableData = response.data.sort();
          this.tableData.forEach((element) => {
            console.log( 'dateFormat');
            console.log( this.dateFormat);
            element.dateOfBirthFormat = moment(element.dateOfBirth).format(
              this.dateFormat.toUpperCase()
            );
          });
          this.currentPage = 1;
          this.updatePagination();
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    enableUser() {
      axios({
        method: "post",
        url: "/users/enableUser",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          userId: this.userDialogData.id,
        },
      })
        .then(() => {
          this.findMatches();
          this.showEnableDialog = false;
          Vue.$toast.open({
            message: "User enabled successfully",
            position: "bottom",
            type: "success",
          });
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    deleteUser() {
      axios({
        method: "post",
        url: "/users/disableUser",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          userId: this.userDialogData.id,
          newUserInitial: this.selectedAsigneeInitial,
          newUserFinal: this.selectedAsigneeFinal,
        },
      })
        .then(() => {
          this.findMatches();
          this.showDeleteDialog = false;
          Vue.$toast.open({
            message: "User disabled successfully",
            position: "bottom",
            type: "success",
          });
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    changeRole(role) {
      var index = this.roleSelect.indexOf(role);
      if (index > -1) {
        this.roleSelect.splice(index, 1);
      } else {
        this.roleSelect.push(role);
      }
      this.findMatches();
    },
    openPreviewDialog(user) {
      this.$material.locale.dateFormat =this.dateFormat;
      this.showPreviewDialog = true;
      this.newUserFlag = false;
      if (!user) {
        this.newUserFlag = true;
        user = {
          firstName: "",
          lastName: "",
          phone: "",
          email: "",
          dateOfBirth: "",
          password: "",
          role: [],
        };
      }
      this.userDialogData = Object.assign({}, user);
      this.userDialogData.dateOfBirth = (
        this.userDialogData.dateOfBirth
          ? moment(this.userDialogData.dateOfBirth)
          : moment()
      ).toDate();
    },
    openPassDialog(user) {
      this.showPassDialog = true;
      this.userPassData = null;
      this.userRePassData = null;
      this.selectedUserPass = Object.assign({}, user);
    },
    openDeleteDialog(user) {
      if (user.disabled) {
        this.showEnableDialog = true;
        this.userDialogData = Object.assign({}, user);
      } else {
        if (
          user.role.indexOf("initial") > -1 ||
          user.role.indexOf("final") > -1
        ) {
          axios({
            method: "get",
            url: "/users/getApprovers?userId=" + user.id,
            baseURL: process.env.VUE_APP_BASE_API,
            headers: {
              Authorization:
                "Bearer " + Vue.prototype.$userData.tokens.access.token,
            },
          })
            .then((response) => {
              if (response.data) {
                this.showDeleteDialog = true;
                this.selectedAsigneeInitial = null;
                this.selectedAsigneeFinal = null;
                this.usersAssignListInitial =
                  user.role.indexOf("initial") > -1
                    ? response.data.initial
                    : [];
                this.usersAssignListFinal =
                  user.role.indexOf("final") > -1 ? response.data.final : [];
                this.userDialogData = Object.assign({}, user);
              }
            })
            .catch(function (error) {
              console.log("FAILURE!!", error);
            });
        } else {
          this.showDeleteDialog = true;
          this.selectedAsigneeInitial = null;
          this.selectedAsigneeFinal = null;
          this.usersAssignListInitial = [];
          this.usersAssignListFinal = [];
          this.userDialogData = Object.assign({}, user);
        }
      }
    },
    updatePagination() {
      this.totalRows = this.tableData.length;

      this.totalPages = Math.ceil(this.totalRows / this.rowsPerPage);
      this.initialRow = (this.currentPage - 1) * this.rowsPerPage;
      this.finalRow = this.currentPage * this.rowsPerPage;
      if (this.finalRow > this.totalRows) {
        this.finalRow = this.totalRows;
      }
      this.paginatedtableData = this.customSort();
    },
    saveUserData() {
      const vm = this;
      vm.userDialogData.dateOfBirth = moment(
        vm.userDialogData.dateOfBirth
      ).format("YYYY-MM-DDT00:00:00Z");
      if (!vm.newUserFlag) {
        axios({
          method: "post",
          url: "/users/update/" + vm.userDialogData.id,
          baseURL: process.env.VUE_APP_BASE_API,
          headers: {
            Authorization:
              "Bearer " + Vue.prototype.$userData.tokens.access.token,
          },
          data: {
            firstName: vm.userDialogData.firstName,
            lastName: vm.userDialogData.lastName,
            username: vm.userDialogData.email,
            phone: vm.userDialogData.phone,
            email: vm.userDialogData.email,
            dateOfBirth: vm.userDialogData.dateOfBirth,
            role: vm.userDialogData.role,
            password: vm.userDialogData.password,
          },
        })
          .then(() => {
            vm.findMatches();
            vm.showPreviewDialog = false;
            Vue.$toast.open({
              message: "User data saved successfully",
              position: "bottom",
              type: "success",
            });
          })
          .catch(function (err) {
            vm.errorMsg = err.response.data
              ? err.response.data.message
              : err.message;
            vm.showError = true;

            console.log("FAILURE!!");
          });
      } else {
        axios({
          method: "post",
          url: "/auth/register",
          baseURL: process.env.VUE_APP_BASE_API,

          data: {
            firstName: vm.userDialogData.firstName,
            lastName: vm.userDialogData.lastName,
            username: vm.userDialogData.email,
            phone: vm.userDialogData.phone,
            email: vm.userDialogData.email,
            dateOfBirth: vm.userDialogData.dateOfBirth,
            role: vm.userDialogData.role,
            password: vm.userDialogData.password,
          },
        })
          .then(() => {
            vm.findMatches();
            vm.showPreviewDialog = false;
            Vue.$toast.open({
              message: "User data created successfully",
              position: "bottom",
              type: "success",
            });
          })
          .catch(function (err) {
            vm.errorMsg = err.response.data
              ? err.response.data.message
              : err.message;
            vm.showError = true;
            console.log("ERROR");
          });
      }
    },
    sendNewPass() {
      axios({
        method: "post",
        url: "/auth/forgot-password",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          username: this.selectedUserPass.username,
        },
      })
        .then(() => {
          this.showPassDialog = false;
          Vue.$toast.open({
            message: "Email sent to the user successfully",
            position: "bottom",
            type: "success",
          });
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    saveUserPass() {
      axios({
        method: "post",
        url: "/auth/reset-password-admin",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          userId: this.selectedUserPass.id,
          password: this.userPassData,
        },
      })
        .then(() => {
          this.showPassDialog = false;
          Vue.$toast.open({
            message: "User password changed successfully",
            position: "bottom",
            type: "success",
          });
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
  mounted() {
    this.role = Vue.prototype.$userData.user.role[0];
    this.isAdmin = Vue.prototype.$userData.user.role.includes('admin');
    this.findMatches();
    this.usersList();
  },
};
</script>

<style lang="scss">
.md-table+.md-table {
  margin-top: 16px;
}

.dialog-content {
  margin: 20px;
  padding: 0px;
}

.md-dialog-title {
  background-color: #e94e1b;
  margin: 0px;
  padding: 20px;
  color: white;
}

.md-selected-row {
  background-color: #dddddd !important;
}

.md-progress-bar.md-determinate.md-theme-default {
  background-color: #8b7b7b !important;
  height: 8px;
}

.md-progress-bar.md-theme-default.md-determinate.md-danger-date .md-progress-bar-fill {
  background-color: #97261e !important;
}

.md-progress-bar.md-theme-default.md-determinate.md-alert-date .md-progress-bar-fill {
  background-color: #d86901 !important;
}
</style>
